<template>
	<div :class="['job-display', { 'teaser': teaser }]">
		<div class="job-display--lines">
			<div class="job-display--line">
				<div class="job-display--box">
					<h4>Beschäftigungsarten</h4>
					<CharacteristicList
						:items="job.employmentMode"
					/>
				</div>
				<div v-if="job.careerLevels" class="job-display--box">
					<h4>Berufsebenen</h4>
					<CharacteristicList
						:items="job.careerLevels"
					/>
				</div>
			</div>
			<div class="job-display--line">
				<div class="job-display--box">
					<h4>Tätigkeiten und Aufgaben</h4>
					<SelectedItems
						:characteristic-items="meta.function"
						:selected="functions"
						:show-additions="false"
						flat
						class="no-left-padding"
					/>
				</div>
			</div>
			<div class="job-display--line">
				<div class="job-display--box">
					<h4>Branchen</h4>
					<div v-if="!industrialSectors || industrialSectors.length === 0">Alle Branchen möglich</div>
					<SelectedItems
						v-else
						:characteristic-items="meta.industrialSector"
						:selected="industrialSectors"
						flat
						class="no-left-padding"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CharacteristicList from "./display/CharacteristicList"
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import {characteristicMultiple} from "@/helper/application/Populate";
import {mapState} from "vuex";

// TODO: rename to Display
export default {

	components: {
		SelectedItems,
		CharacteristicList,
	},

	props: {
		job: {
			type: Object,
			required: true,
		},
		teaser: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	computed: {
		...mapState('meta', ['meta']),
		functions ()
		{
			return characteristicMultiple(
				this.job.functions,
				this.meta,
				this.meta.function,
				this.meta.functionType
			);
		},
		industrialSectors ()
		{
			return characteristicMultiple(
				this.job.industrialSectors,
				this.meta,
				this.meta.industrialSector,
				this.meta.industrialSectorType
			);
		}
	}
}
</script>
